<template>
  <div class="user-area dropdown float-right">
    <!--<SettingsSetter/>-->
    <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-on:click="showDropdownMenu()">
      <span class="nav-item username">
        {{username}}
      </span>
      <img class="user-avatar rounded-circle" src="/img/user.png" alt="User Avatar">
    </a>

    <div class="user-menu dropdown-menu" v-bind:class="{show}" v-on:click="hideDropdownMenu">
      <!--<router-link to="/usermyprofile" tag="li" class="nav-item">-->
        <!--<a class="nav-link" href="#"><i class="fa fa- user"></i>{{ $t('User.myprofile') }}</a>-->
      <!--</router-link>-->
      <!--<router-link to="/login" tag="li" class="nav-item">-->
      <!--<a class="nav-link" href="#"><i class="fa fa- user"></i>{{ $t('User.notifications') }}  &lt;!&ndash;<span class="count">13</span>&ndash;&gt;</a>-->
      <!--</router-link>-->
      <!--<router-link to="/usersettings" tag="li" class="nav-item">-->
        <!--<a class="nav-link" href="#"><i class="fa fa- cog"></i>{{ $t('User.settings') }}</a>-->
      <!--</router-link>-->
      <!--<router-link to="/usersettings" tag="li" class="nav-item">-->
        <!--<a class="nav-link" href="#"><i class="fa fa- cog"></i>{{ $t('User.settings') }}</a>-->
      <!--</router-link>-->
      <router-link to="/usermyprofile" tag="li" class="nav-item">
        <a class="nav-link" href="#"><i class="fa fa-user"></i> {{ $t('LeftMenu.usermyprofile') }}</a>
      </router-link>
      <router-link to="/login" tag="li" class="nav-item">
        <a class="nav-link" href="#"><i class="fa fa-power-off"></i> {{ $t('User.logout') }}</a>
      </router-link>

    </div>
  </div>
</template>

<script>
  import SettingsSetter from '@/components/SettingsSetter.vue';
  export default {
    name: 'User',
    data() {
      return {
        isShow: false,
        show: ""
        , username: ""
      };
    },
    watch: {
      isShow: function (e) {
        if (e) {
          this.show = "show"
        } else {
          this.show = ""
        }
      }
      ,'$store.state.userhash': function (newVal, oldVal) {
        const modul = this;
        modul.username=modul.$store.state.user.email;
//        modul.handleRights();
      },

    },
    mounted() {
      const modul = this;
      if (this.$store.state.displayData && this.$store.state.displayData.name) {
        console.log(this.username)
        this.user = this.$store.state.displayData;
        this.username = this.$store.state.displayData.name;
      }
      this.$store.watch((state) => {
        if (state.displayData && state.displayData.name) {
          this.username = state.displayData.name
        }
      })
      if(modul.$store.state&&modul.$store.state.user){
        modul.username=modul.$store.state.user.email;
      }
    },
    methods: {
      showDropdownMenu(e){
        const modul = this;
        if (this.isShow !== true) {
          this.isShow = true;
        } else {
          this.isShow = false;
        }
      },
      hideDropdownMenu(e){
        const modul = this;
        this.isShow = false;
      },
    },
    components: {
      SettingsSetter
    },

  };
</script>
<style scoped>
  .user-area .user-avatar {
    margin-top: 6px;
    width: 28px;
  }

  .username {
    float: right;
    margin: 0.3em 0 0 0;
  }
</style>
